import React, { useState } from "react";
import { FactsContainer } from "./Facts.styled";
import { FactsTableSection, Filters } from "./components";
import { useFacts } from "./hooks";
import { FactsTrainingModal } from "../../components";

const Facts = ({ onSuggestUpdate }) => {
  const {
    loading,
    tableData,
    headers,
    currentPage,
    itemsPerPage,
    totalItems,
    totalPages,
    filters,
    filterHandlers,
    filterUI,
    sorting,
    handlePageChange,
    handleItemsPerPageChange,
    isTrainingModalOpen,
    setIsTrainingModalOpen,
  } = useFacts({ onSuggestUpdate });

  return (
    <FactsContainer>
      <Filters
        loading={loading}
        filters={filters}
        filterHandlers={filterHandlers}
        filterUI={filterUI}
        sorting={sorting}
      />
      <FactsTableSection
        tableData={tableData}
        headers={headers}
        currentPage={currentPage}
        itemsPerPage={itemsPerPage}
        onItemsPerPageChange={handleItemsPerPageChange}
        onPageChange={handlePageChange}
        totalItems={totalItems}
        totalPages={totalPages}
        loading={loading}
      />
      <FactsTrainingModal
        isOpen={isTrainingModalOpen}
        onClose={() => setIsTrainingModalOpen(false)}
      />
    </FactsContainer>
  );
};

export default Facts;
